import { Component, computed, input, output } from '@angular/core';
import {
  GcButtonComponent,
  GcPillComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { InfoRowComponent } from '../../../../../shared/info-row/info-row.component';
import {
  Building,
  DeliveryPoint,
  InstallationReportOverview,
} from '../../../../entities/installation-reporting-mdu-details.entities';
import { SectionStatusStatuses } from '../../../../entities/installation-reporting-mdu.entities';
import { getDeliveryPointDeliveryStatus } from '../../../../helpers/delivery-status.helper';
import { DeliveryPointBomComponent } from '../delivery-point-bom/delivery-point-bom.component';

@Component({
  selector: 'app-installation-report-overview-tab',
  imports: [
    GcTextComponent,
    GcButtonComponent,
    GcPillComponent,
    IpoTranslatePipe,
    InfoRowComponent,
    DeliveryPointBomComponent,
  ],
  templateUrl: './installation-report-overview-tab.component.html',
  styleUrl: './installation-report-overview-tab.component.scss',
})
export class InstallationReportOverviewTabComponent {
  building = input<Building | null>(null);
  deliveryPoint = input<DeliveryPoint | null>(null);
  overview = input<InstallationReportOverview | null>(null);
  isBom = input(false);
  isBomSaving = input(false);

  bomMarked = output<string>();

  readonly displayBom = computed<boolean>(
    () => !this.building() && !!this.deliveryPoint(),
  );

  deliveryPointsCount = computed<number>(
    () => this.building()?.deliveryPoints?.length ?? 0,
  );

  readonly buildingIsDone = computed<boolean>(
    () => this.building()?.deliveryStatus === 'DONE',
  );

  readonly deliveryPointIsDone = computed<boolean>(() => {
    const point = this.deliveryPoint();
    return (
      !!point &&
      getDeliveryPointDeliveryStatus(point) === SectionStatusStatuses.DONE
    );
  });
}
